module.exports = __webpack_public_path__ + "img/sidebar-1.1fed358a.jpg";